import tailwindIcon from "../../assets/skills/web/tailwindcss.svg";
import pythonIcon from "../../assets/skills/languages/python.png";
import pytorchIcon from "../../assets/skills/ai/pytorch.png";
import reactIcon from "../../assets/skills/web/react.svg";

import dj from "../../assets/DJ.jpg"

import "./description.css";

export default function Description() {
  const techStack = [
    { name: "PyTorch", icon: pytorchIcon },
    { name: "Python", icon: pythonIcon },
    { name: "React", icon: reactIcon },
    { name: "Tailwind CSS", icon: tailwindIcon },
  ];

  return (
    <main className="about-page" id="about">
      <section className="about-section">
        {/* <div className="about-background-word">thestory</div> */}

        <div className="about-heading">
          <div className="glitch_section" data-text="About Me">About Me</div>
          <p>A story of growth and discovery</p>
        </div>

        <div className="about-main">
          <div className="about-image-box">
            <img src={dj} alt="Luis Esteban Acevedo Bringas" />
          </div>

          <div className="about-text">
            <h2>Luis Esteban Acevedo Bringas</h2>
            <p className="about-role">PhD Student / Research Assistant</p>

            <div className="about-description">
              <p>
                Hello! You can call me <strong>Luis</strong>. I am a PhD student
                and researcher working on efficient 3D Human Pose Estimation
                using graph-based Deep Learning methods.
              </p>

              <p>
                My research focuses on designing lightweight neural network
                architectures that maintain strong accuracy while reducing
                computational cost. I am especially interested in computer
                vision, human pose estimation, graph convolutional networks,
                and efficient deep learning.
              </p>

              <p>
                I also enjoy building web projects for real companies and
                organizations. These projects allow me to combine technical
                development with design, usability, and real-world problem
                solving.
              </p>

              <p>
                Outside of research, I continue learning new technologies and
                improving my skills through academic projects, publications,
                and practical software development.
              </p>
            </div>

            <div className="about-stack">
              <p>I am also interested in the following tech stack:</p>

              <div className="about-stack-icons">
                {techStack.map((tool, index) => (
                  <span
                    className="about-stack-tool"
                    key={index}
                    data-tooltip={tool.name}
                    aria-label={tool.name}
                  >
                    <img src={tool.icon} alt={tool.name} />
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <article className="about-now-card">
          <div className="about-now-title">
            <span className="about-now-icon">?</span>
            <h3>What I’m up to now</h3>
          </div>

          <ul className="about-now-list">
            <li>
              Conducting research on efficient 3D human pose estimation using
              Graph Convolutional Networks.
            </li>
            <li>
              Working as a Research Assistant in a university laboratory.
            </li>
            <li>
              Developing web projects and improving my portfolio with reusable
              React components.
            </li>
          </ul>
        </article>


        <article className="about-now-card">
          <div className="about-now-title">
            <span className="about-now-icon">?</span>
            <h3>Outside Dev</h3>
          </div>

          <ul className="about-now-list">
            <li>
              Beyond research and coding, I have an alter ego as a DJ. I usually play Latin music, but sometimes I go full open-format and mix whatever gets people moving.
            </li>
            <li>
              Every Sunday, I play football with my friends — the real one, not the American version with helmets and commercial breaks.
            </li>
            <li>
              I love cooking. Sometimes I run a small food truck or show up as a guest cook at my friends’ restaurants, usually bringing Mexican food, spicy flavors, and a lot of salsa.
            </li>
          </ul>
        </article>

        <article className="about-now-card">
          <div className="about-now-title">
            <span className="about-now-icon">?</span>
            <h3>Fun facts</h3>
          </div>

          <ul className="about-now-list">
            <li>
              I produce music. Nothing is published yet, but I am seriously thinking about opening a SoundCloud account and finally letting the tracks escape my laptop.
            </li>
            <li>
              Some people say I must enjoy pain because I have around 20 tattoos. Honestly, they might be right, because I still want many more.
            </li>
            <li>
              I love gaming. I like any type of video games, but my top three are Rainbow Six Siege, Clone Hero, and Age of Mythology.
            </li>
          </ul>
        </article>

      </section>
    </main>
  );
}